import { ThemeProvider } from '@material-ui/core';
import getCourseTheme from 'assets/themes/Course';
import { useAppSelector } from 'hooks/redux';
import { ICourse } from 'interface/course';

export function withCourseTheme<T = any>(Children: (props: T) => JSX.Element) {
  return (props: T) => {
    const course = useAppSelector((state) => state.course as ICourse);
    const theme = (course && course.customizations && course.customizations.theme) || 0;
    return (
      <ThemeProvider theme={getCourseTheme(theme)}>
        <Children {...props} />
      </ThemeProvider>
    );
  };
}
